export { default } from './components/SearchGCSE'
